module.exports = ".system-maintance-alert {\n  width: 50%;\n  min-height: 49px;\n  position: fixed;\n  top: 0;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  z-index: 99999999999999999999999999999999; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main